import type { EventManager } from '../event-manager.class';

/**
 * Dispose of all event listeners
 */
export const disposeCfn = (self: EventManager, _params: Record<string, never>): void => {
	const config = self.internalConfig;
	const { domElement } = config;

	const handlePointerDown = self.internalHandlePointerDown;
	if (handlePointerDown) {
		domElement.removeEventListener('pointerdown', handlePointerDown);
		self.internalHandlePointerDown = null;
	}

	const handlePointerMove = self.internalHandlePointerMove;
	if (handlePointerMove) {
		domElement.removeEventListener('pointermove', handlePointerMove);
		self.internalHandlePointerMove = null;
	}

	const handleClick = self.internalHandleClick;
	if (handleClick) {
		domElement.removeEventListener('click', handleClick);
		self.internalHandleClick = null;
	}

	const handleDoubleClick = self.internalHandleDoubleClick;
	if (handleDoubleClick) {
		domElement.removeEventListener('dblclick', handleDoubleClick);
		self.internalHandleDoubleClick = null;
	}

	const handleContextMenu = self.internalHandleContextMenu;
	if (handleContextMenu) {
		domElement.removeEventListener('contextmenu', handleContextMenu);
		self.internalHandleContextMenu = null;
	}

	const handleTouchStart = self.internalHandleTouchStart;
	if (handleTouchStart) {
		domElement.removeEventListener('touchstart', handleTouchStart);
		self.internalHandleTouchStart = null;
	}

	const handleMouseMove = self.internalHandleMouseMove;
	if (handleMouseMove) {
		domElement.removeEventListener('mousemove', handleMouseMove);
		self.internalHandleMouseMove = null;
	}
};
